/*
Copyright 2026 Element Creations Ltd.
SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/
import { formatRecordingDate } from "../utils/recordingDate";
import styles from "../RecordingsPage.module.css";

/** Keep the visual date independent of the native picker's intrinsic width and locale. */
export function RecordingDateFilter({
  label,
  value,
  onChange,
  className = "",
}: {
  className?: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
}) {
  return (
    <div className={`${styles.filter} ${styles.dateFilter} ${className}`}>
      <span aria-hidden="true">
        {value ? formatRecordingDate(`${value}T00:00:00`) : "дд/мм/гггг"}
      </span>
      <svg
        aria-hidden="true"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M7 3v4m10-4v4M4 10h16M5 5h14a1 1 0 0 1 1 1v14H4V6a1 1 0 0 1 1-1Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <input
        aria-label={label}
        type="date"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onClick={(event) => {
          try {
            event.currentTarget.showPicker?.();
          } catch {
            /* Native touch picker remains available. */
          }
        }}
        onKeyDown={(event) => {
          if (
            (event.key === "Enter" || event.key === " ") &&
            typeof event.currentTarget.showPicker === "function"
          ) {
            try {
              event.currentTarget.showPicker();
              event.preventDefault();
            } catch {
              /* Keep native keyboard behavior. */
            }
          }
        }}
      />
    </div>
  );
}
